<template>
    <div class="col backgroundForm">
        <div class="col-md-6 offset-md-3">
            <div class="alert alert-info" align="center" role="alert">
                <h4 class="alert-heading">Ordenes de Operaciones</h4>
                <p>Reporte de Ordenes de Operaciones por Persona</p>        
            </div>
        </div>
        
        <nav>
            <div class="nav nav-tabs" id="nav-tab" role="tablist">
                <a class="nav-item nav-link active" id="nav-add-capitan" data-toggle="tab" href="#nav-print-cert" role="tab" aria-controls="nav-new" aria-selected="false"><font-awesome-icon icon="user-plus" /> Certificacion Individual</a>
                <a class="nav-item nav-link" id="nav-add-capitan" data-toggle="tab" href="#nav-reprint-cert" role="tab" aria-controls="nav-new" aria-selected="false"><font-awesome-icon icon="file-pdf" /> Reimpresion ORDOP</a>
            </div>
        </nav>
                
        <div class="tab-content" id="nav-tabContent">                
            <div class="tab-pane fade show active" id="nav-print-cert" role="tabpanel" aria-labelledby="nav-capitan-tab">
                <br><br>
                <h6 align="center">Busqueda y Certificacion de Personas</h6>
                    <hr>
                    <!-- embarcacion encontrada -->
                    <transition name="fade" mode="out-in">

                    <div v-if="person_edit.id > 0" class="panel panel-default">
                        <div class="form-row">
                        <div class="form-group col-12 col-md-4">
                            <label for="type_identification" class="badge badge-primary">Identificacion</label>
                            <div>
                              <input type="text" readonly class="form-control-plaintext" id="staticID" v-model="person_edit.number_identification">
                            </div>
                        </div>

                        <div class="form-group col-12 col-md-4">
                            <label for="number_identification" class="badge badge-primary">Grado </label>
                            <div>
                              <input type="text" readonly class="form-control-plaintext" id="staticEmail" v-model="person_edit.grade">
                            </div>
                        </div>

                        <div class="form-group col-12 col-md-4">
                            <label for="site_expedition" class="badge badge-primary">Especialidad </label>
                            <div>
                              <input type="text" readonly class="form-control-plaintext" id="staticEmail" v-model="person_edit.speciality">
                            </div>
                        </div>
                    </div>

                    <div class="form-row">
                        <div class="form-group col-12 col-md-6">
                            <label for="owner_name" class="badge badge-primary">Nombre y Apellidos</label>
                            <div>
                              <input type="text" readonly class="form-control-plaintext" id="staticEmail" v-model="person_edit.complete">
                            </div>
                        </div>

                        <div class="form-group col-12 col-md-6">
                            <label for="owner_direction" class="badge badge-primary">Telefono </label>
                            <div>
                              <input type="text" readonly class="form-control-plaintext" id="staticEmail" v-model="person_edit.mobile">
                            </div>
                        </div>
                    </div>

                    <div class="form-row">
                        <div class="form-group col-12 col-md-4 offset-md-2">
                            <label for="date_init_ordop">Del : </label>
                            <datetime v-model="dts_millas.date_init" type="date" :phrases="{ok: 'Aceptar', cancel: 'Cerrar'}" input-class="form-control" :format="{year:'numeric', month:'long', day:'numeric'}" placeholder="Seleccione Fecha" title="Fecha de Inicio" value-zone="America/La_Paz"></datetime>
                           
                        </div>
                        <div class="form-group col-12 col-md-4">
                            <label for="date_init_ordop">Al : </label>
                            <datetime v-model="dts_millas.date_end" type="date" :phrases="{ok: 'Aceptar', cancel: 'Cerrar'}" input-class="form-control" :format="{year:'numeric', month:'long', day:'numeric'}" placeholder="Seleccione Fecha" title="Fecha de Inicio" value-zone="America/La_Paz"></datetime>
                           
                        </div>
                    </div>


                <div class="form-row">
                    <div class="form-group col-12 col-md-8 offset-md-2">
                        <label for="owner_name" class="badge badge-primary">Motivo Solicitud</label>
                        <div>
                            <input type="text" class="form-control" id="staticEmail" v-model="motivo_solicitud" autocomplete="off">
                        </div>
                    </div>
                </div>

                <div class="input-group col-8 offset-2">
                    <div class="input-group-prepend">
                        <span class="input-group-text" id="basic-addon1">Correlativo Sistema</span>
                    </div>
                    <input type="text" class="form-control" disabled="disabled" v-model="correlative.co">
                    <div class="input-group-append">
                        <button class="btn btn-outline-secondary" @click="mGenerateCorrelative" type="button"><font-awesome-icon icon="sync-alt" /></button>
                    </div>
                </div>
                <br><br>
                    
                    <button class="btn btn-info col-12 col-md-2 offset-md-4" @click="mReportPersonOrdop()" :disabled="correlative.co===0"><font-awesome-icon icon="file-pdf" size="2x" /></button>
                    <button class="btn btn-danger col-12 col-md-2" @click="mCloseEdit"><font-awesome-icon icon="times-circle" size="2x" :spin="animate" /></button>
                    </div>

                    <!-- busqueda de embarcacion -->
                    <div v-else>
                        <div class="btn-group btn-group-toggle" data-toggle="buttons">
                            <label class="btn btn-success active" @click="mViewSearch">
                                <input class="form-check-input" type="radio" name="exampleRadios" id="exampleRadios1" v-model="optionSearch"  value="document" checked> Nombre 
                            </label>
                            <label class="btn btn-success" @click="mViewSearch">
                                <input class="form-check-input" type="radio" name="exampleRadios" id="exampleRadios2" v-model="optionSearch" value="name">No. Documento
                            </label>
                        </div>

                        <div class="form-group"> 
                            <label for="nombreEmbarcacion">{{ searchType }}</label>
                            <input type="text" class="form-control" id="data_person" v-model="data_person" :placeholder="searchType" autocomplete="off">
                            <small id="enrollmentHelp" class="form-text text-muted">Teclee {{ searchType }} </small>
                        </div>
                    <button class="btn btn-lg btn-outline-primary col col-md-4 offset-md-4" @click="buscaData">Buscar</button>

                        <div class="table-responsive" v-if="list_person_ordop.length > 0">
                            <table class="table table-hover">
                                <thead>
                                    <tr>
                                        <th>#</th>
                                        <th>Nombre Completo</th>
                                        <th>CI</th>
                                        <th><font-awesome-icon icon="check"/></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(persReg, index) in list_person_ordop" :key="persReg.id">
                                        <td>{{ index+1 }}</td>
                                        <td>
                                            <span>{{ persReg.complete }}</span>
                                        </td>
                                        <td>{{ persReg.identification }}</td>
                                        <td>
                                            <button class="btn btn-outline-info" @click="mSelectPersonReport(persReg)">
                                                <font-awesome-icon icon="check"/>
                                            </button>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    </transition>
            </div>
            <!-- end first tab -->
            
            <div class="tab-pane fade show" id="nav-reprint-cert" role="tabpanel" aria-labelledby="nav-capitan-tab">
                <br><br>
                <h6 align="center">Reimpresion de Certificados</h6>
                    <hr>
                    <!-- embarcacion encontrada -->
                    <div class="form-row">
                        <div class="form-group col-12 col-md-4 offset-md-2">
                            <label for="date_init_ordop">Del : </label>
                            <datetime v-model="dts_reprint.date_init" type="date" :phrases="{ok: 'Aceptar', cancel: 'Cerrar'}" input-class="form-control" :format="{year:'numeric', month:'long', day:'numeric'}" placeholder="Seleccione Fecha" title="Fecha de Inicio" value-zone="America/La_Paz"></datetime>
                           
                        </div>
                        <div class="form-group col-12 col-md-4">
                            <label for="date_init_ordop">Al : </label>
                            <datetime v-model="dts_reprint.date_end" type="date" :phrases="{ok: 'Aceptar', cancel: 'Cerrar'}" input-class="form-control" :format="{year:'numeric', month:'long', day:'numeric'}" placeholder="Seleccione Fecha" title="Fecha de Inicio" value-zone="America/La_Paz"></datetime>
                           
                        </div>
                    </div>
                    
                    <button class="btn btn-lg btn-outline-primary col col-md-4 offset-md-4" @click="mListCertificates">Buscar</button>

                        <div class="table-responsive" v-if="list_reprint.length > 0">
                            <table class="table table-hover">
                                <thead>
                                    <tr>
                                        <th>#</th>
                                        <th>Nombre Completo</th>
                                        <th>Certificación</th>
                                        <th><font-awesome-icon icon="check"/></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(persReg, index) in list_reprint" :key="persReg.id">
                                        <td>{{ index+1 }}</td>
                                        <td>
                                            <span>{{ persReg.completo_persona }}</span>
                                        </td>
                                        <td>{{ persReg.correlativo }}/{{ persReg.gestion }}</td>
                                        <td>
                                            <button class="btn btn-outline-info" @click="mSelectPersonReportReprint(persReg.id)">
                                                <font-awesome-icon icon="check"/>
                                            </button>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
            </div>
            <!-- tab de reimpresion certificado -->
            
        </div>
        <modal-loading :id-modal="modal_load_id" :title="modal_load_title" :status-send="status_send"></modal-loading>
    </div>
    </template>
    
    <script>
    import Vue from 'vue';
    import axios from 'axios';
    import modalLoading from '../modal/modalLoading';
    const qs = require('qs');
    
    export default {
        name:'admin-user',
        data(){
            return{
               animate:false,
               owner:{
                    id:0,
                    type_identification:null,
                    number_identification:null,
                    site_expedition:null,
                    name:null,
                    direction:null,
                    mobile:null,
                    phone:null,
                    partner:null,
                    nationality:null
                },
                person_edit:{
                    id:0,
                    complete:null,
                    identification:null,
                    site_expedition:null,
                    birthday:null,
                    grade:null,
                    phone:0,
                    speciality:null
                },
                list_person_ordop:[],
                d_owner_disabled:false,
                d_disabled_partner:false,
                d_owner_disabled_edit:false,
                d_disabled_partner_edit:false,
                types_identification:[],
                citys:[],
                countrys:[],
                status_send:true,
                modal_load_id:'id_owner_new',
                modal_load_title:'Cargando', 
                optionSearch:'name',
                data_person:null,
                dts_millas:{
                    date_init:null,
                    date_end:null
                },
                dts_reprint:{
                    date_init:null,
                    date_end:null
                },
                correlative:{
                    co:0,
                    gestion:0,
                    id:0
                },
                motivo_solicitud:'',
                list_reprint:[]
            }
        },
        mounted(){
            this.getYears();
            
        },
        methods:{
            async mGenerateCorrelative(){
                
                let dts={
                    id_person:this.person_edit.id,
                    complete:`${this.person_edit.grade} ${this.person_edit.speciality} ${this.person_edit.complete}`,
                    motivo:this.motivo_solicitud,
                    fi:this.dts_millas.date_init,
                    ff:this.dts_millas.date_end
                }
                let genCorrelative=await axios.post(`generateCorrelativeOrdop?api_token=${Vue.auth.getToken()}`,qs.stringify(dts));

                // console.log(genCorrelative);
                if(genCorrelative.data.status){
                    toastr.success('Exito', genCorrelative.data.respuesta);
                    this.correlative.co=genCorrelative.data.registro[0].correlativo;
                    this.correlative.gestio=genCorrelative.data.registro[0].gestion;
                    this.correlative.id=genCorrelative.data.registro[0].id;

                }else{
                    toastr.error('Error', genCorrelative.data.respuesta);
                }
            },
            getYears(){
                let ya=new Date();
                this.year_select=ya.getFullYear();
                this.month_select=ya.getMonth()+1;
                const init=2018;
                this.years=[];
                for(let i=init; i<=this.year_select; i++){
                    let ai={c:i};
                    this.years.push(ai);
                }
                let  today = new Date();
                let m = today.getMonth() + 1;
                let mes = (m < 10) ? '0' + m : m;
                let d = today.getDate();
                let dia= (d < 10) ? '0'+d : d;
                let date_aux=today.getFullYear()+'-'+mes+'-'+dia;
                this.dts_millas.date_init=date_aux;
                this.dts_millas.date_end=date_aux;
                this.dts_reprint.date_init=date_aux;
                this.dts_reprint.date_end=date_aux; 
                // this.dts_millas.date_init=`${ya.getFullYear()}-${ya.getDay()}-${ya.getMonth()}`;
            },
            async mListCertificates(){
                this.list_reprint=[];

                let respCert=await axios.get(`getCorrelativeCertificate/${this.dts_reprint.date_init}/${this.dts_reprint.date_end}?api_token=${Vue.auth.getToken()}`);
                console.log(respCert.data);
                if(respCert.data.length>0){
                    this.list_reprint=respCert.data;
                }else{
                    this.toastr.warning('Sin datos', 'No se ha encontrado Datos registrados en estas fechas')
                }
            },
            mSelectPersonReportReprint(idR){
                if(idR!==0){
                    let url_report;
                    // let adi=this.dts_millas.date_init.split('T');
                    // this.dts_millas.date_init=adi[0];
                    // let adf=this.dts_millas.date_end.split('T');
                    // this.dts_millas.date_end=adf[0];

                    // u=`pdfEnrollmentShip/${idb}`;
                    // u=`pdfOrdopGral/${this.captain_report_ordop}/${this.month_select}/${this.year_select}?api_token=${Vue.auth.getToken()}`;
                    url_report=btoa(`pdfMillasICV/${idR}`);
                    let route = this.$router.resolve({path: `/report/${url_report}`});
                    // let route = this.$router.resolve('/link/to/page'); // This also works.
                    // let url='http://localhost:8000/api/pdfOrdopI/140?api_token=PwP5t166M2fKTBZvqkhLEzpJYDgET6NTXypEvInVZjqaVClbK6IgOt2eIw7u'
                    window.open(route.href, 'reporte', 'location=no,toolbar=no,menubar=no,scrollbars=yes,resizable=yes,addressbar=0,titlebar=no,directories=no,channelmode=no,status=no');
                }else{
                    toastr.warning('seleccione una persona', 'Advertencia');
                }
            },
            mReportPersonOrdop(idP=0){
            // aqui llamamos al reporte de millas de la persona de la CC.PP
                if(this.correlative.id!==0){
                    let url_report;
                    let adi=this.dts_millas.date_init.split('T');
                    this.dts_millas.date_init=adi[0];
                    let adf=this.dts_millas.date_end.split('T');
                    this.dts_millas.date_end=adf[0];

                    // u=`pdfEnrollmentShip/${idb}`;
                    // u=`pdfOrdopGral/${this.captain_report_ordop}/${this.month_select}/${this.year_select}?api_token=${Vue.auth.getToken()}`;
                    url_report=btoa(`pdfMillasICV/${this.correlative.id}`);
                    let route = this.$router.resolve({path: `/report/${url_report}`});
                    // let route = this.$router.resolve('/link/to/page'); // This also works.
                    // let url='http://localhost:8000/api/pdfOrdopI/140?api_token=PwP5t166M2fKTBZvqkhLEzpJYDgET6NTXypEvInVZjqaVClbK6IgOt2eIw7u'
                    window.open(route.href, 'reporte', 'location=no,toolbar=no,menubar=no,scrollbars=yes,resizable=yes,addressbar=0,titlebar=no,directories=no,channelmode=no,status=no');
                }else{
                    toastr.warning('seleccione una persona', 'Advertencia');
                }
            },
            mCloseEdit(){
                this.person_edit.id=0;
                this.person_edit.type_identification=0;
                this.person_edit.number_identification=0;
                this.person_edit.site_expedition=0;
                this.person_edit.name=null;
                this.person_edit.direction=null;
                this.person_edit.mobile=null;
                this.person_edit.phone=null;
                this.person_edit.partner=null;
                this.person_edit.nationality=0;
            },
            mSelectPersonReport(sp){
                this.person_edit.id=sp.id;
                this.person_edit.number_identification=sp.identification;
                this.person_edit.complete=sp.complete;
                this.person_edit.mobile=sp.phone;
                this.person_edit.speciality=sp.speciality;
                this.person_edit.grade=sp.grade;
                // this.mChangeOwnerIdentificationEdit();
            },
            buscaData(){
                // console.log(`${this.optionSearch} tipo`);
                // console.log(`${this.data_person}`);
                if(this.data_person !== null || this.data_person.trim().length > 0 ){
                    // console.log('enviando al servidor');
                    axios.get(`searchPersonCompleteType/${this.data_person}/${this.optionSearch}?api_token=${Vue.auth.getToken()}`)
                        .then((res) => {     
                            // console.log(res.data);               
                            this.list_person_ordop = res.data
                            // this.users = res.data.items
                        }).catch(error => {
                            console.log(error);
                        })
                }else{
                    toastr.warning('Indique un valor de busqueda', 'Dato Busqueda');
                }
            },
            mViewSearch(event){
                console.log(event);
                var radios=$("input[type=radio]").parents('label');
                let radioV;                
                    for(let i=0;i<radios.length;i++){                    
                        if($(radios[i]).hasClass('active')){
                            radioV=$(radios[i]).children('input').attr('value');
                        }
                    }
                //console.log(radioV);
                this.optionSearch=radioV;
            },
            mProgressModal(){
                $('#'+this.modal_load_id).modal('show');
            },
            mCloseProgressModal(){
                $('#'+this.modal_load_id).modal('hide');
            },
            mSelectedOwner(data){
                // console.log(data);
                this.owner.id=data.id_propietario;
                this.owner.type_identification=data.tipo_identificacion;
                this.owner.number_identification=data.dato_identificacion;
                this.owner.site_expedition=data.id_expedido;
                this.owner.name=data.nombre_propietario;
                this.owner.direction=data.domicilio;
                this.owner.mobile=data.celular;
                this.owner.phone=data.telefono_fijo;
                this.owner.partner=data.representante_legal;
                this.owner.nationality=data.id_nacionalidad;
                this.d_owner_disabled=true;
                this.d_disabled_partner=true;
            },
            mResetRegisterOwner(){
                this.owner.id=0;
                this.owner.type_identification=null;
                this.owner.number_identification=null;
                this.owner.site_expedition=null;
                this.owner.name=null;
                this.owner.direction=null;
                this.owner.mobile=null;
                this.owner.phone=null;
                this.owner.partner=null;
                this.owner.nationality=null;
                this.d_owner_disabled=false;
                this.d_disabled_partner=false;
            },
            
        },
        components:{
            'modal-loading':modalLoading
        },
        computed:{
            searchType(){
                switch(this.optionSearch){
                    case 'name':
                        return 'Nombre de la Persona';
                    break;
    
                    case 'document':
                        return 'Documento de la Persona';
                    break;
                }
            }
        },
        filters:{
            upperCase(value){
                return value.toUpperCase();
            }
        }
    }
    </script>
    
    <style>
        .required-text{
            color:red; 
            font-weight:bold;
        }
    </style>
    


// WEBPACK FOOTER //
// src/components/ordop/OrdopMillasPersonal.vue